import React from 'react';
import { CreditCard, ShieldCheck } from 'lucide-react';
export function PaymentMethods() {
  return <div className="w-full max-w-md mx-auto mt-4" data-id="element-23">
      <div className="flex items-center justify-center gap-1.5 mb-3 text-sage-light" data-id="element-24">
        <ShieldCheck className="w-4 h-4" data-id="element-25" />
        <p className="text-xs font-medium uppercase tracking-widest" data-id="element-26">
          Pago 100% Seguro
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2" data-id="element-27">
        {/* Tarjetas */}
        <div className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-28">
          <CreditCard className="w-4 h-4 text-cream/80" data-id="element-29" />
          <span className="text-xs font-medium text-cream/90" data-id="element-30">
            Débito / Crédito
          </span>
        </div>

        {/* PSE */}
        <div className="flex items-center bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-31">
          <span className="text-xs font-black italic text-cream/90 tracking-tighter" data-id="element-32">
            pse
          </span>
        </div>

        {/* Nequi */}
        <div className="flex items-center bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-33">
          <span className="text-xs font-bold text-cream/90" data-id="element-34">Nequi</span>
        </div>

        {/* Bancolombia */}
        <div className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-35">
          <div className="flex flex-col gap-[2px]" data-id="element-36">
            <div className="w-2.5 h-[2px] bg-cream/90 rounded-full" data-id="element-37"></div>
            <div className="w-2.5 h-[2px] bg-cream/90 rounded-full" data-id="element-38"></div>
            <div className="w-2.5 h-[2px] bg-cream/90 rounded-full" data-id="element-39"></div>
          </div>
          <span className="text-xs font-bold text-cream/90" data-id="element-40">Bancolombia</span>
        </div>

        {/* Efecty */}
        <div className="flex items-center bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-41">
          <span className="text-xs font-bold text-cream/90" data-id="element-42">efecty</span>
        </div>

        {/* PayPal */}
        <div className="flex items-center bg-white/5 border border-white/10 rounded-md px-3 py-2 hover:bg-white/10 transition-colors" data-id="element-43">
          <span className="text-xs font-bold italic text-cream/90" data-id="element-44">PayPal</span>
        </div>
      </div>
    </div>;
}